export const appConfig = {
    //baseAPIURL: 'https://api.dev.claimlinq.com.au',
    baseAPIURL: 'https://api.stg.claimlinq.com.au',
    //baseAPIURL: 'http://api.claimlinq.loc',
     keyForm: '7f06fdb4-5382-48aa-95a0-527b339c7099',
}
